var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"health-score-badge",class:[_vm.colorClass, `size-${_vm.size}`]},[_c('span',{staticClass:"health-score-badge__dot"}),_c('span',{staticClass:"health-score-badge__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }